import * as tslib_1 from "tslib";
import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { MapConfig } from './models';
var MapService = /** @class */ (function () {
    function MapService(zone, mapConf) {
        this.zone = zone;
        this.mapConf = mapConf;
        this.path = [];
        this.pointers = [];
        this.path = [];
    }
    // init google map
    MapService.prototype.initMap = function (mapElement, options) {
        var _this = this;
        this.s = this.init()
            .pipe(map(function () { return (_this.mapCreate(mapElement, options)); }))
            .subscribe(function (res) { return _this.s.unsubscribe(); });
    }; // initMap()
    MapService.prototype.init = function () {
        var _this = this;
        return Observable.create(function (observer) {
            var d = document, gMap, ref = d.getElementsByTagName('script')[0];
            gMap = d.createElement('script');
            gMap.async = true;
            gMap.src = 'http://maps.googleapis.com/maps/api/js?key=' + _this.mapConf.apiKey;
            gMap.onload = function () {
                observer.next({});
                observer.complete();
            };
            ref.parentNode.insertBefore(gMap, ref);
        });
    }; // ngOnInit()
    /**
     * @method mapPolygon
     * @param polygon
     * @param map
     * @author Rumes
     */
    MapService.prototype.mapPolygon = function (polygon, map) {
        var _this = this;
        if (polygon) {
            this.s.unsubscribe();
            if (this.pointer) {
                this.clearMap(this.pointers);
                this.path = [];
            }
            this.polygon = new google.maps.Polygon({
                paths: this.path,
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#FFFF00',
                fillOpacity: 0.35
            });
            this.polygon.setMap(map);
            this.s = this.subscribeToMapEvent('click').subscribe(function (event) {
                _this.path.push(event.latLng);
                _this.polygon.setPaths(_this.path);
            });
        }
    }; // mapPolygon()
    MapService.prototype.mapMarker = function (pointer, map) {
        var _this = this;
        if (pointer) {
            this.s.unsubscribe();
            this.path = [];
            if (this.polygon) {
                this.polygon.setMap(null);
            }
            this.s = this.subscribeToMapEvent('click').subscribe(function (event) {
                _this.marker = event.latLng;
                _this.pointer = new google.maps.Marker({
                    position: _this.marker
                });
                _this.pointers.push(_this.pointer);
                _this.path.push(event.latLng);
                _this.pointer.setMap(map);
            });
        }
    }; // mapMarker
    /**
     * @method subscribeToEvent
     * @param eventName
     * @returns Observable
     * @author Rumes
     */
    MapService.prototype.subscribeToMapEvent = function (eventName) {
        var _this = this;
        return Observable.create(function (observer) {
            _this.map.addListener(eventName, function (arg) {
                _this.zone.run(function () { return observer.next(arg); });
            });
        });
    };
    MapService.prototype.mapReturn = function () {
        if (this.path.length <= 2) {
            return;
        }
        var points = [];
        this.path.forEach(function (location) {
            points.push({ lat: location.lat(), lng: location.lng() });
        });
        return points;
    };
    MapService.prototype.clearMap = function (array) {
        array.forEach(function (element) {
            element.setMap(null);
        });
    };
    MapService.prototype.mapCreate = function (mapElement, options) {
        var _this = this;
        this.map = new google.maps.Map(mapElement, {
            zoom: options.zoom,
            center: options.center,
            mapTypeId: google.maps.MapTypeId.HYBRID,
            //linksControl: this.mapConf.linksControl,
            panControl: this.mapConf.panControl,
            //enableCloseButton: this.mapConf.enableCloseButton,
            mapTypeControl: this.mapConf.mapTypeControl,
            heading: this.mapConf.heading,
            tilt: this.mapConf.tilt
        });
        if (options.markers.length > 0) {
            options.markers.forEach(function (element) {
                _this.createMarker(element, _this.map);
            });
        }
        //  this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(this.doneButton);
    };
    MapService.prototype.createMarker = function (latlang, map) {
        this.marker = new google.maps.LatLng(latlang.lat, latlang.lng);
        this.pointer = new google.maps.Marker({
            position: this.marker,
            icon: "http://maps.gstatic.com/mapfiles/markers2/icon_green.png"
        });
        this.pointer.setMap(map);
    };
    MapService = tslib_1.__decorate([
        Injectable(),
        tslib_1.__metadata("design:paramtypes", [NgZone, MapConfig])
    ], MapService);
    return MapService;
}()); // End class GoogleMapService
export { MapService };
//# sourceMappingURL=map.service.js.map